export const ignoreSpace = e => {
  if (e.key === ' ') {
    e.preventDefault();
  }
};
